"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractValidationMessage = exports.getUserType = exports.searchPostcode = exports.addToWaitinglist = exports.initFreePayment = exports.initBankTransferPayment = exports.initAfterPayment = exports.initIdealPayment = exports.calculatePrice = exports.getFilters = exports.getCourses = exports.addDownload = exports.deleteCourseDownload = exports.getCourseDownloads = exports.getTeacherSubscriptions = exports.getTeacherData = exports.getStudentData = exports.getViewToken = exports.usernameExists = exports.emailFirstNameComboExists = void 0;
var config_1 = require("./config");
var http_1 = require("./http");
var cookies_1 = require("./cookies");
function emailFirstNameComboExists(email, firstName) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, responseJson;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/student/email-firstname-exists");
                    return [4 /*yield*/, (0, http_1.postJson)(url, {
                            email: email,
                            firstname: firstName,
                        })];
                case 1:
                    response = _a.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseJson = _a.sent();
                    return [2 /*return*/, responseJson.status >= 1];
                case 3: throw "Could not check whether email/firstname combo exists.";
            }
        });
    });
}
exports.emailFirstNameComboExists = emailFirstNameComboExists;
function usernameExists(username) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, responseText, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/user/username-exists?username=").concat(username);
                    return [4 /*yield*/, (0, http_1.get)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    _a = parseInt;
                    return [4 /*yield*/, response.text()];
                case 2:
                    responseText = _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/, responseText >= 1];
                case 3: throw "Could not check whether email/firstname combo exists.";
            }
        });
    });
}
exports.usernameExists = usernameExists;
function getViewToken(id, type) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/view-token");
                    return [4 /*yield*/, (0, http_1.postJson)(url, {
                            foreign_key_type: type,
                            foreign_key_id: id,
                        }, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.getViewToken = getViewToken;
function getStudentData() {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/student");
                    return [4 /*yield*/, (0, http_1.get)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.getStudentData = getStudentData;
function getTeacherData() {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/teacher");
                    return [4 /*yield*/, (0, http_1.get)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.getTeacherData = getTeacherData;
function getTeacherSubscriptions() {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/teacher/subscriptions");
                    return [4 /*yield*/, (0, http_1.get)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.getTeacherSubscriptions = getTeacherSubscriptions;
function getCourseDownloads(courseId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/downloads/").concat(courseId);
                    return [4 /*yield*/, (0, http_1.get)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.getCourseDownloads = getCourseDownloads;
function deleteCourseDownload(downloadId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/downloads/").concat(downloadId);
                    return [4 /*yield*/, (0, http_1.del)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.deleteCourseDownload = deleteCourseDownload;
function addDownload(courseId, file) {
    return __awaiter(this, void 0, void 0, function () {
        var formData, url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    formData = new FormData();
                    formData.append("file", file);
                    formData.append("course", courseId.toString());
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/downloads");
                    return [4 /*yield*/, (0, http_1.postFormData)(url, formData, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.addDownload = addDownload;
function getCourses() {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "filter/courses-asc");
                    return [4 /*yield*/, (0, http_1.get)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.getCourses = getCourses;
function getFilters() {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "filter/all");
                    return [4 /*yield*/, (0, http_1.get)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.getFilters = getFilters;
function calculatePrice(courseId, discountCode, customFields) {
    return __awaiter(this, void 0, Promise, function () {
        var url, request, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/price/calc");
                    request = {
                        course_id: courseId,
                    };
                    if (discountCode) {
                        request.discount_code = discountCode;
                    }
                    if (customFields) {
                        request.custom_fields = customFields;
                    }
                    return [4 /*yield*/, (0, http_1.postJson)(url, request, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.text()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.calculatePrice = calculatePrice;
function initIdealPayment(courseId, studentId, isAvailableAsContact, discountCode, customFields) {
    return __awaiter(this, void 0, void 0, function () {
        var url, request, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/payment/ideal");
                    request = {
                        available_as_contact: isAvailableAsContact,
                        course_id: courseId,
                        student_id: studentId,
                    };
                    if (discountCode) {
                        request.discount_code = discountCode;
                    }
                    if (customFields) {
                        request.custom_fields = customFields;
                    }
                    return [4 /*yield*/, (0, http_1.postJson)(url, request, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.initIdealPayment = initIdealPayment;
function initAfterPayment(invoiceId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/payment/after-pay/").concat(invoiceId);
                    return [4 /*yield*/, (0, http_1.get)(url, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.initAfterPayment = initAfterPayment;
function initBankTransferPayment(courseId, studentId, isAvailableAsContact, discountCode, customFields) {
    return __awaiter(this, void 0, void 0, function () {
        var url, request, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/payment/bank");
                    request = {
                        available_as_contact: isAvailableAsContact,
                        course_id: courseId,
                        student_id: studentId,
                    };
                    if (discountCode) {
                        request.discount_code = discountCode;
                    }
                    if (customFields) {
                        request.custom_fields = customFields;
                    }
                    return [4 /*yield*/, (0, http_1.postJson)(url, request, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.initBankTransferPayment = initBankTransferPayment;
function initFreePayment(courseId, isAvailableAsContact, discountCode, customFields) {
    return __awaiter(this, void 0, void 0, function () {
        var url, request, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/payment/free");
                    request = {
                        available_as_contact: isAvailableAsContact,
                        course_id: courseId,
                    };
                    if (discountCode) {
                        request.discount_code = discountCode;
                    }
                    if (customFields) {
                        request.custom_fields = customFields;
                    }
                    return [4 /*yield*/, (0, http_1.postJson)(url, request, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.initFreePayment = initFreePayment;
function addToWaitinglist(request) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/waitinglist");
                    return [4 /*yield*/, (0, http_1.postJson)(url, request, (0, http_1.getHeaders)())];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 201)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.addToWaitinglist = addToWaitinglist;
function searchPostcode(postcode) {
    return __awaiter(this, void 0, Promise, function () {
        var url, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, config_1.getApiRootUrl)(), "api/postcode/").concat(postcode);
                    return [4 /*yield*/, (0, http_1.get)(url)];
                case 1:
                    response = _b.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = undefined;
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    });
}
exports.searchPostcode = searchPostcode;
function getUserType() {
    var cookies = (0, cookies_1.parseCookies)();
    if (!cookies) {
        return null;
    }
    return cookies["hovo-user-type"];
}
exports.getUserType = getUserType;
function extractValidationMessage(response, defaultErrorMessage) {
    return __awaiter(this, void 0, void 0, function () {
        var body, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.json()];
                case 1:
                    body = _a.sent();
                    message = defaultErrorMessage;
                    if (Array.isArray(body)) {
                        message = body.join("\n");
                    }
                    else if (typeof body === "string") {
                        message = body;
                    }
                    return [2 /*return*/, message];
            }
        });
    });
}
exports.extractValidationMessage = extractValidationMessage;
